import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Cargando...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner" />
      <span className="loading-spinner-message">{message}</span>
    </div>
  );
};

export default LoadingSpinner;
